import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import * as R from 'ramda'
import { useHistory } from 'react-router-dom'

import { DomainsPresentation } from '.'
import { Loader } from 'shared/components/Loader'
import useAxios from 'hooks/useAxios'
import { AdminContainer } from '../../pages/Admin'

import { AllowPermission } from 'shared/components/AllowPermission'
import { AddDomainModal } from 'organisms/AddDomainModal'
import { DnsRecordModal } from 'organisms/DnsRecordModal/container'
import PageHeaderContainer from 'shared/components/PageHeader/container'
import constants from 'config/constants'

const LoaderWrapper = styled.div`
  min-height: 100px;
  position: relative;
`

export function EmailContainer() {
  const [openAddDomainModal, setOpenAddDomainModal] = useState(false)
  const [openDomainId, setOpenDomainId] = useState(null)

  const {
    data: domains,
    loading,
    error,
  } = useAxios({
    url: 'sendgrid/whitelabel/domains?limit=500',
  })

  const history = useHistory()

  useEffect(() => {
    if (R.prop('openModal', history.location.state)) {
      setOpenAddDomainModal(true)
      history.replace(history.location.path)
    }
  }, [history])

  const openDomain = domains && domains.find((domain) => domain.id === openDomainId)

  return (
    <React.Fragment>
      <PageHeaderContainer
        title="Email authentication"
        rightSlot={
          <AllowPermission permission={constants.permissions.manageEmailAuthentication}>
            <AddDomainModal isForceModalOpen={openAddDomainModal} existingDomains={domains} />
          </AllowPermission>
        }
      />

      <AdminContainer>
        <div className="ui segment admin-section">
          {loading ? (
            <LoaderWrapper>
              <Loader />
            </LoaderWrapper>
          ) : (
            <DomainsPresentation domains={domains} error={!!error} onRowClick={setOpenDomainId} />
          )}
        </div>
      </AdminContainer>
      {openDomain && (
        <DnsRecordModal domain={openDomain} isOpen onClose={() => setOpenDomainId(null)} />
      )}
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/EmailSetting/container.js